(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/mode-shift-link.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/mode-shift-link.js');

'use strict';

const {
  Link
} = svs.app.ReactRouter;
const {
  bankIdPollType,
  route
} = svs.playerLogin.constants;

const ModeShiftLink = _ref => {
  let {
    isLogin = true,
    isBankId = true,
    pollState = bankIdPollType.BEFORE_POLL
  } = _ref;
  return React.createElement("div", {
    className: svs.core.detect.feature('ft-bankid-secure-start') ? 'margin-bottom-1' : ''
  }, pollState !== bankIdPollType.SPINNER_POLL && React.createElement("div", {
    className: "margin-xs-top-2"
  }, isLogin && React.createElement("span", {
    className: "login-react-hover"
  }, React.createElement(Link, {
    className: "f-inverted f-bold u-text-decoration-underline",
    title: "Bli kund",
    to: isBankId ? route.REGISTRATE_BANKID_START_ROUTE : route.REGISTRATE_FREJAEID_ROUTE
  }, "Bli kund")), !isLogin && React.createElement("span", {
    className: "login-react-hover"
  }, React.createElement(Link, {
    className: "f-inverted f-bold u-text-decoration-underline",
    title: "Logga in",
    to: isBankId ? route.LOGIN_BANKID_START_ROUTE : route.LOGIN_FREJAEID_ROUTE
  }, "Redan kund?"))));
};
svs.playerLogin.sharedComponents.ModeShiftLink = ModeShiftLink;

 })(window);